import Portal from './Portal.jsx'

export const Component = Portal;

export default Component;
